import { getPlayerRanking, getTeamRanking } from "../../../api";

export const fetchPlayerRanking = async ({
  provider,
  discipline,
  statType,
  competitionIds = [],
  season,
  page = 1,
  limit = 10,
  sort = 'value_desc',
}) => {
  const { data } = await getPlayerRanking({
    provider,
    discipline,
    statType,
    competitionIds,
    season,
    page,
    limit,
    sort,
  });

  return data;
};

export const fetchTeamRanking = async ({
  provider,
  discipline,
  statType,
  competitionIds = [],
  season,
  page = 1,
  limit = 10,
  sort = 'value_desc',
}) => {
  const { data } = await getTeamRanking({
    provider,
    discipline,
    statType,
    competitionIds,
    season,
    page,
    limit,
    sort,
  });

  return data;
};